import React from 'react';
import Banner from '../Banner/Banner';
import Extra from '../Extra/Extra';
import Services from '../Services/Services';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Services></Services>
            <Extra></Extra>
        </div>
    );
};

export default Home;